import { useId } from 'react';

import {
  Checkbox,
  Label,
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger
} from 'design-system';

interface FilterOptionRowProps {
  label: string;
  count: number;
  checked: boolean;
  onChange: () => void;
  showCount?: boolean;
}

const FilterOptionRow = ({
  label,
  count,
  checked,
  onChange,
  showCount = true
}: FilterOptionRowProps) => {
  const isEmpty = count === 0 && !checked;
  const checkboxId = useId();

  return (
    <div
      className={`flex w-full gap-2 px-3 py-2 ${isEmpty ? 'cursor-not-allowed text-muted-foreground' : 'cursor-pointer'}`}
      data-disabled={isEmpty || undefined}
    >
      <Checkbox
        checked={checked}
        className={isEmpty ? 'invisible' : undefined}
        disabled={isEmpty}
        id={checkboxId}
        onCheckedChange={onChange}
      />
      <Label
        className='flex min-w-0 flex-1 cursor-inherit items-center justify-between gap-2'
        htmlFor={checkboxId}
      >
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger
              render={
                <span className='block min-w-0 overflow-hidden text-ellipsis whitespace-nowrap'>
                  {label}
                </span>
              }
            />
            <TooltipContent>{label}</TooltipContent>
          </Tooltip>
        </TooltipProvider>
        {showCount ? (
          <span className='shrink-0 text-[10px] text-muted-foreground'>
            {count.toLocaleString('en-US')}
          </span>
        ) : null}
      </Label>
    </div>
  );
};

export default FilterOptionRow;
